import { GovernanceDecisionValue } from '../contract/constants.js';
import { immutable } from '../contract/stable.js';

const nonEmpty = (value) => typeof value === 'string' && value.trim().length > 0;

export function createQuarantineRecord(input) {
  const requiredStrings = ['quarantineId', 'requestId', 'sourceTraceId', 'createdAt', 'status'];
  for (const key of requiredStrings) {
    if (!nonEmpty(input?.[key])) throw new Error(`QUARANTINE_RECORD_INVALID: ${key} must be non-empty`);
  }
  if (!Array.isArray(input.evidenceIds) || input.evidenceIds.length === 0 || input.evidenceIds.some((id) => !nonEmpty(id))) {
    throw new Error('QUARANTINE_RECORD_INVALID: evidenceIds must be non-empty');
  }
  if (!Array.isArray(input.reasonCodes) || input.reasonCodes.length === 0 || input.reasonCodes.some((code) => !nonEmpty(code))) {
    throw new Error('QUARANTINE_RECORD_INVALID: reasonCodes must be non-empty');
  }
  if (input.governanceDecision !== GovernanceDecisionValue.QUARANTINE) {
    throw new Error('QUARANTINE_RECORD_INVALID: governanceDecision must be QUARANTINE');
  }
  return immutable({
    ...input,
    evidenceIds: immutable([...new Set(input.evidenceIds)]),
    reasonCodes: immutable([...new Set(input.reasonCodes)])
  });
}
